<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1>Users
        <button class="ml-3 btn btn-invite" @click.prevent="addUser">
          <font-awesome-icon class="orange mr-2" size="sm" icon="plus"/>Add User
        </button>
        </h1>
      </div>
      </div>

    <div class="container-fluid">
      <div class="row user-header">
        <div class="col-2">Name</div>
        <div class="col-2">ID</div>
        <div class="col-2">E-Mail</div>
        <div class="col-2">Roles</div>
        <div class="col-2"></div>
        <div class="col-2"></div>
      </div>

    <div v-for="user in userResponse.users" class="row user-row" :key="user.userId">
            <div class="col-2 column align-middle">{{ user.firstName + ' ' + user.lastName }}</div>
            <div class="col-2 column align-middle">{{ user.userId }}</div>
            <div class="col-2 column align-middle">{{ user.emailAddress }}</div>
            <div class="col-2 column align-middle">
             <div v-for="role in user.roles" :key="role.id"> {{ role ? role : 'None' }} </div>
            </div>
            <div class="col-4 column text-right">
            <button title="Edit" @click.prevent="editUser(user)" type="button" class="btn btn-outline-orange m-1 wide-button">
              <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
            </button>
            <button title="Delete" @click.prevent="deleteUser(user)" type="button" class="btn btn-outline-orange m-1 wide-button">
              <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
            </button>
            <button title="Email Password Reset" @click.prevent="forgotUserPassword(user)" type="button" class="btn btn-outline-orange m-1 wide-button">
              Password Reset
            </button>
            </div>
    </div>
    </div>

    <user-modal :edit-user="editingUser" @updated="userUpdated" :visible="showingUserModal"
                @update:visible="visible => showingUserModal = visible"></user-modal>
    <paginator :totalPages="totalPages" :currentPage="currentPage" @update:currentPage="newPage => currentPage = newPage"></paginator>
  </div>
</template>

<script>
  import api from '../services/api'
  import Paginator from '@/components/Paginator'
  import UserModal from '@/components/UserModal'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'Users',

    components: { Paginator, UserModal },

    mixins: [AnalyticsMixin],

    data () {
      return {
        isLoading: true,
        userResponse: [],
        errors: [],
        showingUserModal: false,
        showingUserList: false,
        editingUser: {},
        totalPages: 0,
        currentPage: 1,
        pageSize: 20,
        searchTerm: ''
      }
    },

    watch: {
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadData()
        }
      }
    },

    methods: {
      loadData () {
        this.isLoading = true

        const parameters = {
          searchTerm: this.searchTerm,
          pageSize: this.pageSize,
          page: this.currentPage
        }

        api.post('/Dashboard/Users/Search', parameters).then(response => {

          this.userResponse = response.data
          this.totalPages = Math.ceil(response.data.totalUsers / this.pageSize)
          this.isLoading = false
        }).catch(error => {
          this.isLoading = false
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to load users: ' + error.message, error)
          }
        })
      },

      addUser () {
        this.editingUser = {}
        this.showingUserModal = true
      },

      editUser (user) {
        this.editingUser = user
        this.showingUserModal = true
      },

      deleteUser (user) {
        this.errorMessage = ''
        api.delete('/Dashboard/Users/' + user.userId).then(() => {
          this.loadData()
          this.changed = true
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.errors = ['Error deleting user' + error.message]
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'DeleteUser', error)
          }
        })
      },

      forgotUserPassword (user) {
        api.post('Dashboard/Users/' + user.userId + '/ForgotPassword').then(() => {
          this.loadData()
          this.changed = true
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.errors = ['Error sending password reset email' + error.message]
            this.setFromApiErrorResponse(error)
            this.trackEvent(this.$options.name, 'ForgotUserPassword', error)
          }
        })
      },

      userUpdated () {
        this.showingUserModal = false
        this.loadData()
      }
    },

    created () {
      this.loadData()
    }
  }
</script>

<style scoped>
  .header div h1 {
    color: rgb(255, 70, 0);
    font-weight: lighter;
    font-size: 28px;
    margin: 0;
  }

  .header > h5 {
    margin-top: 0.5rem; /* Match bottom margin from bootstrap h5 */
  }

  .user-header div {
    padding: 0.75rem;
    vertical-align: bottom;
    border-top: 1px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    font-weight: bold;
    border-collapse: collapse;
    width: 100%;
  }

  .user-row .column {
    padding: 0.75rem;
    vertical-align: bottom;
    border-collapse: collapse;
  }

  .user-row {
    border-bottom: 1px solid #dee2e6;
    background-color: #f9f9f9;
    /*cursor: pointer;*/
  }

  .btn-invite {
    border-color: rgb(255, 70, 0);
  }

</style>
